/**
 * @desc 已放行信息提交
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.CustomsClearanceYFXRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/customsClearance/yfxCustomsClearance`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
